export const CANONICAL_DOMAIN = 'www.ebl.lmu.de'
export const CANONICAL_ORIGIN = `https://${CANONICAL_DOMAIN}`
